import React, { useState, useEffect } from "react";
import { Heart } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { getFavourites } from "../api";
import PropertyCard from "../components/PropertyCard";
import AuthModal from "../components/AuthModal";

const Favourites = () => {
  const { user, loading } = useAuth();
  const [props, setProps] = useState([]);
  const [authOpen, setAuthOpen] = useState(false);
  const [fetching, setFetching] = useState(true);

  useEffect(() => {
    if (user) {
      getFavourites().then(setProps).catch(() => setProps([])).finally(() => setFetching(false));
    } else if (!loading) {
      setFetching(false);
    }
  }, [user, loading]);

  return (
    <div className="min-h-[70vh] bg-[#faf7f2]">
      <div className="bg-[#1c1c1e] py-16">
        <div className="max-w-[1280px] mx-auto px-5 md:px-8">
          <p className="text-[12px] tracking-[0.28em] uppercase text-[#d9b98a] mb-2">Your Collection</p>
          <h1 className="font-display text-white text-[36px] md:text-[46px] font-300">Saved Homes</h1>
        </div>
      </div>

      <div className="max-w-[1280px] mx-auto px-5 md:px-8 py-14">
        {!user ? (
          <div className="text-center py-16">
            <Heart size={40} className="text-[#d8cdbb] mx-auto mb-4" />
            <p className="font-display text-[24px] text-[#2b2b2b] mb-2">Sign in to view saved homes</p>
            <p className="text-[14px] text-[#8a8a8a] mb-6">Save your favourite properties and access them anytime.</p>
            <button onClick={() => setAuthOpen(true)} className="px-7 py-3 rounded-full bg-[#b8935f] text-white text-[14px] font-500 hover:bg-[#a67f4d] transition-colors">
              Sign In
            </button>
            <AuthModal open={authOpen} onOpenChange={setAuthOpen} defaultMode="login" />
          </div>
        ) : fetching ? (
          <p className="text-center py-16 font-display text-[20px] text-[#8a8a8a]">Loading saved homes...</p>
        ) : props.length === 0 ? (
          <div className="text-center py-16">
            <Heart size={40} className="text-[#d8cdbb] mx-auto mb-4" />
            <p className="font-display text-[24px] text-[#2b2b2b] mb-2">No saved homes yet</p>
            <p className="text-[14px] text-[#8a8a8a] mb-6">Tap the heart on any property to save it here.</p>
            <Link to="/buying" className="px-7 py-3 rounded-full bg-[#b8935f] text-white text-[14px] font-500 hover:bg-[#a67f4d] transition-colors">
              Browse Properties
            </Link>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
            {props.map((p) => <PropertyCard key={p.id} property={p} />)}
          </div>
        )}
      </div>
    </div>
  );
};

export default Favourites;
